var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var VirtusPasswordValidator = /** @class */ (function () {
    function VirtusPasswordValidator(rules) {
        this.rules = rules;
    }
    VirtusPasswordValidator.prototype.addRule = function (rule) {
        this.rules.push(rule);
    };
    VirtusPasswordValidator.prototype.removeRule = function (key) {
        var newRulesObjArr = this.rules.filter(function (obj, i) {
            return Object.keys(obj)[0] !== key;
        });
        if (newRulesObjArr.length !== this.rules.length) {
            this.rules = newRulesObjArr;
            return true;
        }
        else {
            return false;
        }
    };
    VirtusPasswordValidator.prototype.doesRulePass = function (obj, password) {
        var key = Object.keys(obj)[0];
        var regExPassed = !!password.match(obj[key]);
        return regExPassed;
    };
    VirtusPasswordValidator.prototype.doAllRulesPass = function (password) {
        var _this = this;
        return this.rules
            .map(function (obj) { return _this.doesRulePass(obj, password); })
            .reduce(function (acum, curr) {
            return curr ? acum : false;
        });
    };
    VirtusPasswordValidator.prototype.check = function (password) {
        var _this = this;
        var rulesPassedObj = {};
        this.rules.forEach(function (obj) {
            var _a, _b;
            var regExPassed = _this.doesRulePass(obj, password);
            var key = Object.keys(obj)[0];
            var splitWords = key.match(/([A-Z][a-z]*)|([a-z]+)|(\d+)/g);
            if (splitWords) {
                rulesPassedObj = __assign(__assign({}, rulesPassedObj), (_a = {}, _a[splitWords.join(" ").toLowerCase()] = regExPassed, _a));
            }
            else {
                rulesPassedObj = __assign(__assign({}, rulesPassedObj), (_b = {}, _b[key.toLowerCase()] = regExPassed, _b));
            }
        });
        return rulesPassedObj;
    };
    return VirtusPasswordValidator;
}());
export { VirtusPasswordValidator };
export var virtusPasswordValidatorDefaultRules = [
    { mustBe8CharactersOrLonger: /^.{8,}$/g },
    { mustIncludeACapitalLetter: /[A-Z]/g },
    { mustIncludeALowercaseLetter: /[a-z]/g },
    { mustIncludeANumber: /\d/g },
    { mustIncludeASpecialCharacter: /[^A-Za-z0-9]/g },
];
